import React, { useState, useEffect } from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";

// Icons
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
// Components
import CheckTable from "./CheckTable"; //reused table component
import CheckAddItem from "./CheckAddItem"; //reused modal component
//React Router (for getting parameters)
import { useParams, NavLink } from "react-router-dom";
import {
  get_cookies,
  isLoggedIn,
  timeZoneChanger,
} from "../../components/Cookies/Cookies";
//number format plugin
import numeral from "numeral";
import Autocomplete from "@material-ui/lab/Autocomplete";
import DateFnsUtils from "@date-io/date-fns";
import { format } from "date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import MessageBox from "../../components/MessageBox/MessageBox";
import { Breadcrumbs, Typography } from "@material-ui/core";

const useStyles = makeStyles({
  card: {
    marginBottom: "1rem",
  },
  cardHeader: {
    borderBottom: "1px solid #4aba4a",
    padding: "1.3rem 24px 2rem 24px",
  },
  title: {
    marginTop: "0",
    color: "#339933",
    fontWeight: "700",
    fontSize: "1.1rem",
  },
  subTitle: {
    fontSize: "0.8rem",
    marginBottom: "0.5rem",
    fontWeight: "700",
    textTransform: "uppercase",
    color: "#339933",
  },
  infoContainer: {
    marginBottom: "2rem",
    backgroundColor: "rgba(137, 200, 59, 0.09)",
    padding: "1rem",
    border: "1.5px solid #4aba4a",
    borderRadius: "5px",
  },
  infoTitle: {
    fontWeight: "700",
    fontSize: "14px",
  },
  infoContent: {
    fontSize: "14px",
  },
  buttonContainer: {
    textAlign: "right",
    "& button": {
      marginLeft: "0.5rem !important",
    },
  },
  infoTotal: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop: "1rem",
  },
  infoTotalItem: {
    padding: "0.5rem 1rem",
    border: "1px solid #4aba4a",
    borderRadius: "5px",
    display: "flex",
    alignItems: "center",
    marginBottom: "0.5rem",
    fontWeight: "700",
  },
  infoTotalIcon: {
    marginRight: "0.5rem",
    color: "#4caf50 !important",
  },
  textarea: {
    width: "100%",
    marginTop: "1rem",
  },
  miniTitle: {
    fontSize: "0.8rem",
    marginBottom: "0.5rem",
    fontWeight: "700",
    textTransform: "uppercase",
    color: "#339933",
  },
});

const CheckEdit = () => {
  const { chkno, branchidno } = useParams();
  const branchIdNo = get_cookies("branchidno");
  const [purchaseType, setPurchaseType] = useState(null);
  const [supplier, setSupplier] = useState([]);
  const [accountIndex, setAccountIndex] = useState("");
  const [supplierIndex, setSupplierIndex] = useState("");
  const [glAccounts, setGlAccounts] = useState([]);
  const [supplierId, setSupplierId] = useState([]);
  const [reference, setReference] = useState("");
  const classes = useStyles();
  const [poTotal, setPoTotal] = useState(0);
  const [notes, setNotes] = useState("");
  const [selectedDate, setSelectedDate] = React.useState();
  //state for disabling/enabling button
  const [btnDisabled, setBtnDisabled] = useState(true);

  const [showModal, setShowModal] = useState(false);
  const [showMsgBox, setShowMsgBox] = useState(false);
  const [msgBoxContent, setMsg] = useState("Empty");
  const [msgType, setMsgType] = useState("success");

  let history = useHistory();
  const [items, setItems] = useState([]); //data to display in table

  useEffect(() => {
    let po_total = 0;
    items.forEach((item) => (po_total += item.amount));
    setPoTotal(po_total);
    if (items.length > 0) {
      setBtnDisabled(false); // re-enable
    } else {
      setBtnDisabled(true); // re-enable
    }
  }, [items, reference, supplierId, purchaseType]);

  const handleDateChange = (date) => {
    date = format(date, "yyyy-MM-dd");
    setSelectedDate(date);
  };

  const checkType = [
    {
      type: "Purchases",
    },
    {
      type: "Expenses",
    },
  ];

  const checkSupplierProps = {
    options: checkType,
    getOptionLabel: (option) => option.type,
  };
  const selectSupplierProps = {
    options: supplier,
    getOptionLabel: (option) => option.suppliername,
  };
  // componentDidMount / document.ready ?
  useEffect(() => {
    data();
    // getCheckDetails();
  }, []);
  useEffect(() => {
    getCheckDetails();
  }, [supplier]);


  const x = 0;
  useEffect(() => {
    //
    timeZoneChanger(setSelectedDate);
    isLoggedIn();
  }, [x]);

  const getSupplierList = async () => {
    await axios
      .get(process.env.REACT_APP_API_URL + "/get_supplier_list", {
        params: {
          jc_user_id_no: branchIdNo, //branchIdNo
        },
      })
      .then((res) => {
        setSupplier(res.data.data);
      })
      .catch((error) => {
        // console.log(error.message);
      });
  };
  const getGlAccountList = async () => {
    await axios
      .get(process.env.REACT_APP_API_URL + "gl_accounts_list", {
        params: {
          branch: get_cookies("branchidno"),
        },
      })
      .then((res) => {
        // console.log("gl_account", res);
        setGlAccounts(res.data[0]);
      })
      .catch((error) => {
        // console.log(error.message);
      });
  };

  const data = async () => {
    getSupplierList();
    getGlAccountList();
  };

  const addItem = (item) => {
    //add new unique item to array
    setItems([
      ...items,
      {
        id: item.id,
        date: item.date,
        description: item.description,
        amount: item.amount,
        gl_account: item.gl_account,
        gl_account_id: item.gl_id,
      },
    ]);
  };
  const deleteItem = (id) => {
    let itemArray = items.filter((item) => item.id != id);
    setItems(itemArray);
  };

  const getCheckDetails = async () => {
    await axios
      .get(process.env.REACT_APP_API_URL + "/check_approval_form", {
        params: {
          chkno: chkno,
          jc_u_idno: branchIdNo,
        },
      })
      .then((res) => {

        let supplierArray = res.data.data[0].general_info.payto;
        let checke = res.data.data[0].general_info.type;


        setAccountIndex(checke);
        setSupplierIndex(supplierArray);

        setPurchaseType(checke)
        // let checkTypeArray = [checkObj];
        // setSupplier(supplierObj[0].suppliername);
        // setPurchaseType(checkObj[0]);
       let supplierData= supplier.find(sup => sup.suppliername === supplierArray)

       if(supplier!= undefined){
    
        setSupplierId(supplierData.id);
       }
        setReference(res.data.data[0].general_info.reference);
        setSelectedDate(res.data.data[0].general_info.date);
        setPoTotal(res.data.data[0].general_info.grandtotal);
        setNotes(res.data.data[0].general_info.notes);
              setItems([
                ...items,
                ...res.data.data[1].item_info.map(info => ({
                  id: info.description,
                  date: info.date,
                  description: info.description,
                  amount: info.amount,
                  gl_account: info.gl_account.description,
                  gl_account_id: info.gl_account_id,
                })),
              ]);
      })
      .catch((error) => {
        // console.log(error.message);
      });
  };

  // item_array:
  // jc_uname:postmanapi
  // jc_u_idno:DAVAOHQ
  // supid:3
  // refno:9999
  // checktype:Purchases
  // notes:api save check
  // trandate:2021-03-15
  const save_check = async () => {
    setBtnDisabled(true); // disable button to avoid multiple saves
    setShowModal(true); //show loading/please wait modal
    const formData = new FormData();
    formData.append("item_array", JSON.stringify(items));
    formData.append("jc_uname", get_cookies("username"));
    formData.append("jc_u_idno", get_cookies("branchidno"));
    formData.append("supid", supplierId);
    formData.append("chkno", chkno);
    formData.append("refno", reference);
    formData.append("checktype", purchaseType);
    formData.append("notes", notes);
    formData.append("trandate", format(new Date(selectedDate), "yyyy-MM-dd"));

    await axios
      .post(process.env.REACT_APP_API_URL + "update_check", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(function (res) {
        const response_checkno = res.data.chkdata;
        setShowModal(false); //hide loading/please wait modal
        setShowMsgBox(true);
        setMsg("Updated Check");
        setMsgType("success");
        setTimeout(() => {
          setShowMsgBox(false);
          setBtnDisabled(false); // re-enable
          history.push(`/account/check-transaction-history`);
        }, 2000);
      })
      .catch(function (error) {
        setShowModal(false); //hide loading/please wait modal
        setShowMsgBox(true);
        setMsg("Something went wrong: " + error.response.data.error);
        setMsgType("warning");
        setTimeout(() => {
          setShowMsgBox(false);
          setBtnDisabled(false); // re-enable
        }, 2500);
      });
  };

  return (
    <div className="page">
      <div className="page-header">
        <div className="page-icon">
          <AccountBalanceWalletIcon />
        </div>
        <Breadcrumbs aria-label="breadcrumb">
          <NavLink to="/account">
            <h2 className="header-title">Accounts</h2>
          </NavLink>
          <h2 >Update Check #{chkno}</h2>
        </Breadcrumbs>
      </div>
      <div className="page-container">
        <MessageBox in={showMsgBox} content={msgBoxContent} type={msgType} />
        <Card className={classes.card}>
          <div className={classes.cardHeader}>
            <Grid container spacing={0} style={{ justifyContent: "flex-end" }}>
              <Grid item xs={8}>
                <div className={classes.title}>Check Information</div>
              </Grid>
              <Grid item xs={2} style={{ textAlign: "right" }}></Grid>
              <Grid item xs={2} className={classes.buttonContainer}>
                {glAccounts ? (
                  <CheckAddItem addItem={addItem} glAccounts={glAccounts} />
                ) : (
                  <></>
                )}
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs="6">
                  <form noValidate autoComplete="off">
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        // disableToolbar
                        // maxDate={new Date().setMonth(new Date().getMonth() + 12)}
                        minDate={new Date().setMonth(new Date().getMonth() - 6)}
                        variant="inline"
                        format="MMM dd, yyyy"
                        id="date-picker-inline"
                        label="Transaction Date"
                        value={selectedDate}
                        disabled={true}
                        onChange={handleDateChange}
                        inputVariant="outlined"
                        margin="normal"
                        className={classes.date}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                      />
                    </MuiPickersUtilsProvider>

                    <TextField
                          style={{ marginTop: "5px" }}
                      value={accountIndex??""}
                      label="Select Type"
                      margin="normal"
                      fullWidth={true}
                      variant="outlined"
                      aria-readonly={true}
                    />

                    <TextField
                          style={{ marginTop: "5px" }}
                      value={supplierIndex?? ""}
                      label="Select Supplier"
                      margin="normal"
                      fullWidth={true}
                      aria-readonly={true}
                      variant="outlined"
                    />

                    <TextField
                           aria-readonly={true}
                      style={{ marginTop: "5px" }}
                      id="outlined-required"
                      label="Reference"
                      variant="outlined"
                      fullWidth={true}
                      className={classes.field}
                      value={reference} //to avoid label overlapping bug
                //       onChange={(e) => {
                //         setReference(e.target.value);
                //       }}
                    />
                  </form>
                </Grid>
              </Grid>
            </Grid>
          </div>
          <CardContent>
            <CheckTable items={items} deleteItem={deleteItem} />
            <div className={classes.infoTotal}>
              <div className={classes.infoTotalContent}>
                <div className={classes.infoTotalItem}>
                  <ShoppingCartTwoToneIcon className={classes.infoTotalIcon} />
                  {"Total: " + numeral(poTotal).format("0,0.00")}
                </div>
              </div>
            </div>
            <TextField
              label="Notes"
              multiline
              rows={4}
              variant="outlined"
              value={notes} //to avoid label overlapping bug
              onChange={(e) => {
                setNotes(e.target.value);
              }}
              className={classes.textarea}
            />
          </CardContent>
        </Card>
        <br />
        <div className={classes.buttonContainer}>
          {/* <Button variant="contained">Back</Button>  */}
          <Button
            disabled={btnDisabled}
            variant="contained"
            color="primary"
            onClick={() => {
              save_check();
            }}
          >
            Update Check
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CheckEdit;
